import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ReceptionMobileListItem } from './ReceptionMobileListItem';
import { IReceptionListProps } from './types';

export const ReceptionMobileList: React.FC<IReceptionListProps> = ({
  visitors,
  signingOut,
  onClick,
  onSignOut,
}) => (
  <Row>
    {visitors.map((visitor) => (
      <Col key={visitor.id} lg={6} xl={4} className="mb-2">
        <ReceptionMobileListItem
          visitor={visitor}
          signedOut={visitor.outAt !== null}
          isSigningOut={signingOut.indexOf(visitor.id) !== -1}
          onClick={() => onClick(visitor.id)}
          onSignOut={() => onSignOut(visitor)}
        />
      </Col>
    ))}
  </Row>
);
